import React, { useState, useEffect } from 'react';
import { Layout, Input, Select, Form, message, Row, Col } from 'antd';
import queryString from 'query-string';
import get from 'lodash/get';

import PickUpPointService from 'services/pickup-point';
import WarehouseService from 'services/warehouse';

import PdButton from 'components/pd-button';
import { errHandling } from 'utils';
import { useLocation, useNavigate } from 'react-router-dom';

const { Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;

const FIELDS = {
  ADDRESS: 'address',
  PICKUP_ID: 'pickup_id',
  TITLE: 'title',
  WAREHOUSE_ID: 'warehouse_id',
};

export function PickUpPointForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loadingButton, setLoadingButton] = useState(false);
  const [, setValue] = useState({});
  const [warehouseList, setWarehouseList] = useState([]);

  const { id } = queryString.parse(get(location, 'search', {}));

  async function handleSubmit(values) {
    setLoadingButton(true);
    const payload = {
      pickup_point: values,
    };

    try {
      if (id) {
        await PickUpPointService.updatePickUpPoint(payload, id);
        message.success('successfully updated pickup point');
      } else {
        await PickUpPointService.createPickUpPoint(payload);
        message.success('successfully created pickup point');
      }

      navigate('/pickup_points/location/');
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingButton(false);
    }
  }

  async function getPickUpPointDetails() {
    try {
      const { data: { data } = {} } =
        await PickUpPointService.getPickUpPointDetails(id);
      const { warehouse: { id: warehouse_id } = {} } = data;
      setValue({ ...data, warehouse_id });
      form.setFieldsValue({ ...data, warehouse_id });
    } catch (error) {
      errHandling(error);
    }
  }

  async function getWarehouseList() {
    try {
      const {
        data: { data },
      } = await WarehouseService.getWarehouseList();
      setWarehouseList(data);
    } catch (error) {
      errHandling(error);
    }
  }

  useEffect(() => {
    if (id) {
      getPickUpPointDetails();
    }
    getWarehouseList();
    // eslint-disable-next-line
  }, []);

  return (
    <Layout className="main-container">
      <div className="content">
        <div className="pageTitle">Create New Pick Up Point</div>
        <Content className="pageContent">
          <Form layout="vertical" form={form} onFinish={handleSubmit}>
            <div className="section-container">
              <div className="inner-section">
                <Form.Item
                  label="Pick Up Point Name"
                  name={FIELDS.TITLE}
                  rules={[
                    {
                      message: 'Please input Pick Up Point Name',
                      required: true,
                    },
                  ]}>
                  <Input placeholder="Input pickup point name here" />
                </Form.Item>
                <Form.Item
                  label="Pick Up Point ID"
                  name={FIELDS.PICKUP_ID}
                  rules={[
                    {
                      message: 'Please input Pick Up Point ID',
                      required: true,
                    },
                  ]}>
                  <Input placeholder="Input pickup point id here" />
                </Form.Item>
                <Form.Item
                  label="Address"
                  name={FIELDS.ADDRESS}
                  rules={[
                    {
                      message: 'Please input address',
                      required: true,
                    },
                  ]}>
                  <TextArea />
                </Form.Item>
                <Form.Item
                  label="Warehouse"
                  name={FIELDS.WAREHOUSE_ID}
                  rules={[
                    {
                      message: 'Please select warehouse',
                      required: true,
                    },
                  ]}>
                  <Select>
                    {warehouseList.map(({ title, id }) => (
                      <Option value={id} key={id}>
                        {title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item>
                  <Row gutter={8}>
                    <Col span={12}>
                      <PdButton
                        type="primary"
                        full
                        onClick={() => navigate(-1)}>
                        Back
                      </PdButton>
                    </Col>
                    <Col span={12}>
                      <PdButton
                        full
                        htmlType="submit"
                        loading={loadingButton}
                        type="primary">
                        Publish
                      </PdButton>
                    </Col>
                  </Row>
                </Form.Item>
              </div>
            </div>
          </Form>
        </Content>
      </div>
    </Layout>
  );
}
